import { IPeriodConfiguration, NameBuilderConfiguration, AggregationConfiguration, TrendLogbookEntriesType } from '../../../models/';
import { ChartConfigurationOption } from '../../../wtFramework';
import { PeriodReference } from '../../enum/PeriodReference';
import { SeriesConfiguration } from '../../../widgets';

export class TagsTrendConfiguration implements IPeriodConfiguration {
    aggregation: AggregationConfiguration;
    alignedOn: PeriodReference;
    hideMissing: boolean;
    isBoundToGroup: boolean;
    isEndDateIncluded = false;
    logbookEntriesShownType: TrendLogbookEntriesType;
    maxPeriod: any;
    minPeriod: any;
    nameConfiguration: NameBuilderConfiguration;
    options: ChartConfigurationOption;
    series: SeriesConfiguration[];
    showAlarms: boolean;
    showLogbook: boolean;

    constructor() {
        this.series = [];
        this.options = new ChartConfigurationOption();
        this.aggregation = new AggregationConfiguration();
        this.hideMissing = false;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.nameConfiguration.hasUnit = true;
        this.alignedOn = PeriodReference.End;
    }
}